import { SalesCompsRequest } from "../../../dataTypes/properties/salesCompsRequest";
export interface SalesCompsFiltersState extends SalesCompsRequest {}
export const initialSalesCompsFiltersState: SalesCompsFiltersState = new SalesCompsRequest();
